import { render } from "./ExpiredFollowUp.vue?vue&type=template&id=3f52c5d4"
import script from "./ExpiredFollowUp.vue?vue&type=script&lang=js"
export * from "./ExpiredFollowUp.vue?vue&type=script&lang=js"

import exportComponent from "S:\\_Projects\\TRC4\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_5cff2737dde116e8fc1156af408c1302\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__